import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";
import Breakpoints from "common/breakpoints";

export default makeStyles((theme: MuiTheme) => ({
  appSideBarRoot: {
    position: "sticky",
    top: 0,
    maxHeight: "100dvh",
    whiteSpace: "nowrap",
    width: theme.widthDesktopDrawer,
    zIndex: theme.zIndex.app.sidebar,
    boxShadow: "1px 0px 7px 0px rgba(0, 0, 0, 0.15)",
    backgroundColor: theme.palette.common.white,
    [theme.breakpoints.down("md")]: {
      width: `calc(${theme.widthTabletDrawer}px)`
    },
    [theme.breakpoints.down(Breakpoints.SM_600)]: {
      display: "none"
    }
  },
  appSideBarRootShadowless: {
    boxShadow: "none"
  },
  appSideBarContent: {
    height: "100dvh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    flex: "auto",
    [theme.breakpoints.down(Breakpoints.SM_600)]: {
      height: "initial"
    }
  },
  appSideBarLinks: {
    height: "100%",
    overflow: "auto",
    marginTop: 64,
    "&.swipeableDrawerOpen": {
      marginTop: 134
    }
  }
}));
